var map = {
	"./de/glossary.json": [
		92415,
		2415
	],
	"./de/translation.json": [
		99805,
		9805
	],
	"./en/glossary.json": [
		72501,
		2501
	],
	"./en/translation.json": [
		22830,
		2830
	],
	"./es/glossary.json": [
		25976,
		5976
	],
	"./es/translation.json": [
		6336,
		6336
	],
	"./fr/glossary.json": [
		25988,
		5988
	],
	"./fr/translation.json": [
		93932,
		5806
	],
	"./pt/glossary.json": [
		85795,
		5795
	],
	"./pt/translation.json": [
		85856,
		5856
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 10471;
module.exports = webpackAsyncContext;